import { useState } from "react"
import { useToast } from "../../context/useToast"
import { useService } from "../../context/useService"
import { useSession, useSupabase } from "../../context/useSupabase"

export const usePrivateInvestmentsReports = () => {
  const [date, setDate] = useState(null)
  const { reportService } = useService()
  const toast = useToast()
  const session = useSession()
  const supabase = useSupabase()

  const update = async () => {
    try {
      await supabase.auth.refreshSession()
      await reportService.refreshIlliquidReport(date.year(), date.month() + 1, session.access_token)
      toast.success({ message: "Refresh initialized! After some minutes, update Power BI to see the changes." })
      setDate(null)
    } catch (error) {
      toast.error({ message: "Error while refreshing the report" })
      console.error("Error while refreshing the report", error)
    }
  }

  return { date, setDate, update }
}
